<div class="passcode-container">
  <div class="passcode-title">
    <ion-button (click)="onClose()" class="close">
      <i class="far fa-times-circle icon"></i>
    </ion-button>
    <h3 class="title">Request Passcode</h3>
  </div>

  <ion-list class="list">
    <ion-list-header class="header">
      Delivery Method:
    </ion-list-header>

    <ion-radio-group [(ngModel)]="deliveryMethod" class="group">
      <ion-item class="item">
        <ion-radio value="email" class="radio"></ion-radio>
        <ion-label class="label">
          <i class="fas fa-envelope icon"></i>
          Email
        </ion-label>
      </ion-item>

      <ion-item class="item">
        <ion-radio value="sms" class="radio"></ion-radio>
        <ion-label class="label">
          <i class="fas fa-comments icon"></i>
          SMS
        </ion-label>
      </ion-item>
    </ion-radio-group>
  </ion-list>

  <div [formGroup]="emailForm">
    <form *ngIf="deliveryMethod === 'email'"
          (ngSubmit)="onSubmit()"
          class="passcode-form">
      <ion-item class="item" [ngClass]="getClass(emailForm, 'email', 'email')">
        <ion-label position="stacked">
          Email<span class="required">*</span>
        </ion-label>
        <ion-input type="email"
                   [formControl]="emailForm.controls['email']"
                   [placeholder]="'Enter Email'"
                   class="input">
        </ion-input>
      </ion-item>

      <div class="rules">
        <strong>Email rules:</strong>
        <ul>
          <li [ngClass]="getClass(emailForm, 'email', 'email')">
            Should be valid
          </li>
          <li [ngClass]="getClass(emailForm, 'email', 'required')">
            Required
          </li>
        </ul>
      </div>

      <ion-button type="submit"
                  [disabled]="!emailForm.controls['email'].valid"
                  class="button">
        <i class="fas fa-paper-plane icon"></i>
        Send PassCode
      </ion-button>
    </form>
  </div>

  <div [formGroup]="smsForm">
    <form *ngIf="deliveryMethod ==='sms'"
          (ngSubmit)="onSubmit()"
          class="passcode-form">
      <ion-item class="item" [ngClass]="getClass(smsForm, 'phoneNumber', 'pattern')">
        <ion-label position="stacked">
          Phone Number<span class="required">*</span>
        </ion-label>
        <ion-input type="text"
                   [formControl]="smsForm.controls['phoneNumber']"
                   [placeholder]="'Enter Phone Number'"
                   class="input">
        </ion-input>
      </ion-item>

      <div class="rules">
        <strong>Phone Number rules:</strong>
        <ul>
          <li [ngClass]="getClass(smsForm, 'phoneNumber', 'pattern')">
            Should be valid, eg. (123) 456-7890 or 1234567890
          </li>
          <li [ngClass]="getClass(smsForm, 'phoneNumber', 'required')">
            Required
          </li>
        </ul>
      </div>

      <ion-button type="submit"
                  [disabled]="!smsForm.controls['phoneNumber'].valid"
                  class="button">
        <i class="fas fa-paper-plane icon"></i>
        Send PassCode
      </ion-button>
    </form>
  </div>
</div>
